import React, { useState, useEffect } from 'react';
import { styled } from "../stitches.config"

import { bodyLarge } from "./commonStyles/Fonts";
import ToggleSwitch from './ToggleSwitch';

interface ToggleButtonProps {
    active: boolean,
    text: string,
    onToggle?: () => void,
    autoToggle?: boolean,
}

const ToggleButton: React.FC<ToggleButtonProps> = ({
    active,
    text,
    onToggle,
    autoToggle = true,
    ...props
}) => {
    const [isActive, setActive] = useState(active);
    const toggleClass = () => {
        autoToggle && setActive(!isActive);
        onToggle && onToggle()
    };

    useEffect(() => {
        setActive(active);
    }, [active]);

    return (
        <StyledToggleButton className={bodyLarge()} onClick={toggleClass}>
            <span className={isActive ? "active" : ""}>{text}</span>
            <ToggleSwitch active={isActive} />
        </StyledToggleButton>
    );
};


const StyledToggleButton = styled('div', {
    border: "1px solid $grayscale25",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 12px",
    pointerEvents: "none",
    "& span": {
        color: "$grayscale50"
    },

    "& .active": {
        color: "$grayscale100"

    }
})


export default ToggleButton